// Actions
const FETCH_SHARED_TOKENS = 'zen/dashboardLinkAccess/FETCH_SHARED_TOKENS';
const FETCH_SHARED_TOKENS_SUCCEEDED = 'zen/dashboardLinkAccess/FETCH_SHARED_TOKENS_SUCCEEDED';
const FETCH_SHARED_TOKENS_FAILED = 'zen/dashboardLinkAccess/FETCH_SHARED_TOKENS_FAILED';

const UPDATE_SHARED_TOKEN = 'zen/dashboardLinkAccess/UPDATE_SHARED_TOKEN';
const UPDATE_SHARED_TOKEN_SUCCEEDED = 'zen/dashboardLinkAccess/UPDATE_SHARED_TOKEN_SUCCEEDED';
const UPDATE_SHARED_TOKEN_FAILED = 'zen/dashboardLinkAccess/UPDATE_SHARED_TOKEN_FAILED';

const DELETE_SHARED_TOKEN = 'zen/dashboardLinkAccess/DELETE_SHARED_TOKEN';
const CONFIRM_DELETE_SHARED_TOKEN = 'zen/dashboardLinkAccess/CONFIRM_DELETE_SHARED_TOKEN';
const CANCEL_DELETE_SHARED_TOKEN = 'zen/dashboardLinkAccess/CANCEL_DELETE_SHARED_TOKEN';
const DELETE_SHARED_TOKEN_SUCCEEDED = 'zen/dashboardLinkAccess/DELETE_SHARED_TOKEN_SUCCEEDED';
const DELETE_SHARED_TOKEN_FAILED = 'zen/dashboardLinkAccess/DELETE_SHARED_TOKEN_FAILED';

const CLICK_ICON = 'zen/dashboardLinkAccess/CLICK_ICON';
const MOUSE_LEAVE_ICON = 'zen/dashboardLinkAccess/MOUSE_LEAVE_ICON';

export const initialState = {
  sharedTokensList: [],
  confirmSharedToken: null,
  fetchSharedTokensError: null,
  fetchingSharedTokens: true,
  updateSharedTokenSuccess: null,
  updateSharedTokenError: null,
  updatingSharedToken: false,
  deleteSharedTokenError: null,
  deletingSharedToken: false,
  clickedIcon: false,
  successText: null
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  const { sharedTokensList } = state;
  let successText;
  let updatedSharedTokensList;
  switch (action.type) {
    case FETCH_SHARED_TOKENS:
      return {...state, fetchingSharedTokens: true};
    case FETCH_SHARED_TOKENS_SUCCEEDED:
      return {...state, sharedTokensList: action.payload, fetchingSharedTokens: false, fetchSharedTokensError: null};
    case FETCH_SHARED_TOKENS_FAILED:
      return {...state, fetchingSharedTokens: false, fetchSharedTokensError: action.payload};
    case UPDATE_SHARED_TOKEN:
      return {...state, updatingSharedToken: true};
    case UPDATE_SHARED_TOKEN_SUCCEEDED:
      updatedSharedTokensList = sharedTokensList.map((token) => {
        if (token._id === action.payload._id) {
          // This works for now for the two possible successText messages.
          // If we add more messages, we should consider using one generic success message
          successText = token.active !== action.payload.active
            ? `Link access ${action.payload.active ? 'enabled' : 'disabled'}`
            : 'Expiration Extended';
          return action.payload;
        }
        return token;
      });
      return {
        ...state, sharedTokensList: updatedSharedTokensList, successText,
        updateSharedTokenError: null, updatingSharedToken: false, updateSharedTokenSuccess: true
      };
    case UPDATE_SHARED_TOKEN_FAILED:
      return {
        ...state, updateSharedTokenError: action.payload,
        updatingSharedToken: false, updateSharedTokenSuccess: false
      };
    case CONFIRM_DELETE_SHARED_TOKEN:
      return {...state, confirmSharedToken: action.payload};
    case CANCEL_DELETE_SHARED_TOKEN:
      return {...state, confirmSharedToken: null};
    case DELETE_SHARED_TOKEN:
      return {...state, deletingSharedToken: true};
    case DELETE_SHARED_TOKEN_SUCCEEDED:
      updatedSharedTokensList = sharedTokensList.filter( (token) => token._id !== state.confirmSharedToken._id );
      return {
        ...state, sharedTokensList: updatedSharedTokensList,
        deleteSharedTokenError: null, deletingSharedToken: false, confirmSharedToken: null
      };
    case DELETE_SHARED_TOKEN_FAILED:
      return {
        ...state,  deleteSharedTokenError: action.payload,
        deletingSharedToken: false, confirmSharedToken: null
      };
    case CLICK_ICON:
      return {...state, clickedIcon: true };
    case MOUSE_LEAVE_ICON:
      return {...state, clickedIcon: false, successText: null};
    default: return state;
  }
};

// Action Creators
const fetchSharedTokens = (campaignId) => {
  return { type: FETCH_SHARED_TOKENS, campaignId };
};

const fetchSharedTokensSucceeded = (payload) => {
  return { type: FETCH_SHARED_TOKENS_SUCCEEDED, payload };
};

const fetchSharedTokensFailed = () => {
  return { type: FETCH_SHARED_TOKENS_FAILED };
};

const updateSharedToken = (payload) => {
  return { type: UPDATE_SHARED_TOKEN, payload };
};

const updateSharedTokenSucceeded = (payload) => {
  return { type: UPDATE_SHARED_TOKEN_SUCCEEDED, payload };
};

const updateSharedTokenFailed = () => {
  return { type: UPDATE_SHARED_TOKEN_FAILED };
};

const confirmDeleteSharedToken = (payload) => {
  return { type: CONFIRM_DELETE_SHARED_TOKEN, payload };
};

const cancelDeleteSharedToken = () => {
  return { type: CANCEL_DELETE_SHARED_TOKEN };
};

const deleteSharedToken = (payload) => {
  return { type: DELETE_SHARED_TOKEN, payload };
};

const deleteSharedTokenSucceeded = (payload) => {
  return { type: DELETE_SHARED_TOKEN_SUCCEEDED, payload };
};

const deleteSharedTokenFailed = () => {
  return { type: DELETE_SHARED_TOKEN_FAILED };
};

const clickIcon = () => {
  return { type: CLICK_ICON };
};

const mouseLeaveIcon = () => {
  return { type: MOUSE_LEAVE_ICON };
};


export default reducer;
export {
  // Actions
  FETCH_SHARED_TOKENS,
  FETCH_SHARED_TOKENS_SUCCEEDED,
  FETCH_SHARED_TOKENS_FAILED,
  UPDATE_SHARED_TOKEN,
  UPDATE_SHARED_TOKEN_SUCCEEDED,
  UPDATE_SHARED_TOKEN_FAILED,
  DELETE_SHARED_TOKEN,
  CONFIRM_DELETE_SHARED_TOKEN,
  CANCEL_DELETE_SHARED_TOKEN,
  DELETE_SHARED_TOKEN_SUCCEEDED,
  DELETE_SHARED_TOKEN_FAILED,
  CLICK_ICON,
  MOUSE_LEAVE_ICON,
  // Action Creators
  fetchSharedTokens,
  fetchSharedTokensSucceeded,
  fetchSharedTokensFailed,
  updateSharedToken,
  updateSharedTokenSucceeded,
  updateSharedTokenFailed,
  deleteSharedToken,
  confirmDeleteSharedToken,
  cancelDeleteSharedToken,
  deleteSharedTokenSucceeded,
  deleteSharedTokenFailed,
  clickIcon,
  mouseLeaveIcon
};
